import { combineReducers } from 'redux'
import {
  GET_VISTOR_FAIL, GET_VISITOR_SUCCESS, PUSH_VISITOR, VISITOR_IS_LOADING
} from "./action-types.js"; 
//import { Object } from "core-js";

const initialState = {
  visitor: {},
  isLoading: false,
  error: ""
};

const visitorReducer = (state = initialState, action) => {
  switch (action.type) {

    case PUSH_VISITOR:
      const ns = {
        ...state, visitor: { ...state.visitor, ...action.data }
      }
      //console.log("PUSH_VISITOR", state, ns, action.data)
      return ns;
    case GET_VISITOR_SUCCESS:
      return { ...state, shops: action.shops };
    case VISITOR_IS_LOADING:
      return { ...state, isLoading: action.isLoading };

    default:
      return state;
  }
};

export default visitorReducer;